/**
 * Review types
 *
 * @type {object}
 */
export const reviewTypes = {
  review: 'review',
  vote: 'vote'
};
export const reviewTypesTitle = {
  [reviewTypes.review]: 'Отзыв',
  [reviewTypes.vote]: 'Оценка'
};
/**
 * Attachments types
 *
 * @type {object}
 */

export const attachmentsTypes = {
  image: 'image',
  video: 'video'
};
export const attachmentsTitles = {
  [reviewTypes.image]: 'Изображение',
  [reviewTypes.video]: 'Видео'
};